import { render, staticRenderFns } from "./addImageTypeVant.vue?vue&type=template&id=331cbb02&"
import script from "./addImageTypeVant.vue?vue&type=script&lang=js&"
export * from "./addImageTypeVant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports